


































































































































































































































































import IInboundDeliveryNotes from '@/store/models/IInboundDeliveryNotes';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';
import IWarehouse from '@/store/models/IWarehouse';
import IInbound from '@/store/models/IInbound';
import InboundDeliveryNotesDetailSelector from '@/components/selectors/Inbounds/InboundDeliveryNotesDetailSelector.vue';
import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import IListPalletType from '@/store/models/IListPalletType';
import IGood from '@/store/models/IGood';
import IInboundDetail from '@/store/models/IInboundDetail';
import moment from 'moment';
import IListStatusInboundDeliveryNotes from '@/store/models/IListStatusInboundDeliveryNotes';
import Snackbar from '@/components/shared/Snackbar.vue';
import IListDock from '@/store/models/IListDock';
import IStock from '@/store/models/IStock';
import { EMPTY_GUID, EMPTY_DOCK_GUID } from '@/config/constants';

@Component({
    components: {
        InboundDeliveryNotesDetailSelector,
        Snackbar
    }
})
export default class InboundDeliveryNotesSelector extends Vue {
    menu2: boolean = false;
    searchInboundDeliveryNotes: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    dialogPrinting: boolean = false;
    selectedFormatToPrint: string = "";
    sortBy: string = 'dateIn';
    sortDesc: boolean = false;
    editedIndex : number = -1;
    editedItem : IInboundDeliveryNotes = {
        id: "",
        idInbound: "",
        inboundCode: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        idStatus: "",
        statusName: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }
    defaultItem : IInboundDeliveryNotes = {
        id: "",
        idInbound: "",
        inboundCode: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        idStatus: "",
        statusName: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }

    @Prop({ type: Array, required: true })
    InboundDeliveryNotesList !: IInboundDeliveryNotes[];
    @Prop({ type: Array })
    InboundDeliveryNotesDetailList !: IInboundDeliveryNotesDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop({ type: Array, required: true })
    WarehouseList !: IWarehouse[];
    @Prop({ type: Array, required: true })
    ListStatusInboundsDeliveryNotes !: IListStatusInboundDeliveryNotes[];
    @Prop()
    SelectedInbound !: IInbound;
    @Prop({ type: Array })
    InboundDetailDeliveryNotesDetailList !: IInboundDetail[];
    @Prop({ type: Array, required: true })
    PalletTypesList !: IListPalletType[];
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop()
    value !: IInboundDeliveryNotes;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedInbounds !: boolean;
    @Prop({ type: Boolean, default: false })
    IsSelectedWarehouseShared !: boolean;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedInboundsDeliveryNotes !: boolean;
    @Prop()
    CompanyId !: string;
    @Prop({ type: Boolean, default: false })
    ScannerActive !: boolean;
    @Prop({ type: Array, required: true })
    ListDocks !: IListDock[];
    @Prop({ type: Array, default: () => [] })
    StockAvailableForInbound !: IStock[];

    selectedInboundDeliveryNotes : IInboundDeliveryNotes[] = [];
    selectedWarehouse : any = null;
    selectedCompanySource : ICompany = {} as ICompany;
    selectedCompanyDestination : ICompany = {} as ICompany;
    selectedStatus: IListStatusInboundDeliveryNotes = {} as IListStatusInboundDeliveryNotes;
    canChangeWarehouse: boolean = true;
    dateIn: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    selectedDock: IListDock = {} as IListDock;
    overlay: boolean = false;

    @Watch('selectedWarehouse')
    onWarehouseChanged(newVal: IWarehouse | null) {
        if (newVal && newVal.id) {
            // 🚀 Avisamos al padre para que determine si el warehouse es shared
            this.$emit('checkWarehouseShared', newVal.id);
        }
    }

    get headers() {
        const baseHeaders = [
            { text: 'Company source', align: 'start', value: 'companySourceName' },
            { text: 'Company destination', value: 'companyDestinationName' },
            { text: 'Warehouse', value: 'warehouseName' }
        ];

        if (this.ScannerActive) {
            baseHeaders.push({ text: 'Dock', value: 'dockName' });
        }

        baseHeaders.push(
            { text: 'Customer', value: 'customerName' },
            { text: 'Code Delivery Note', value: 'code' },
            { text: 'Dossier Number Source', value: 'codeSource' },
            { text: 'Dossier Number Destination', value: 'codeDestination' },
            { text: 'Date in', value: 'dateIn' },
            { text: 'Description', value: 'description' },
            { text: 'Status', value: 'statusName' }
        );

        if (this.ScannerActive) {
            baseHeaders.push({ text: 'Picked', value: 'dockPicked' });
        }

        baseHeaders.push({ text: 'Actions', value: 'actions' });

        return baseHeaders;
    }

    get DateInFormatted() {
        return this.formatDate(this.dateIn);
    }

    get canEdit() {
        return this.InboundDeliveryNotesDetailList.length > 0;
    }

    get sortedWarehouseList() {
        return this.WarehouseList.slice().sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    get filteredDocks() {
        if (!this.selectedWarehouse) return [];
        return this.ListDocks.filter(d => d.idWarehouse === this.selectedWarehouse.id);
    }

    getStatus(status: string) {
        if (this.IsSelectedWarehouseShared) {
            return status;
        }
        return "";
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    HasRightModifyCompletedInbounds() {
        if (!this.Permissions[0].isWritable || (this.SelectedInbound.statusName === 'Completed' && !this.CanModifyCompletedInbounds)) return false;
        return true;
    }

    parseDate (date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    get formTitle() { return this.editedIndex === -1 ? 'New Delivery Notes' : 'Edit Delivery Notes'; }

    @Watch('InboundDeliveryNotesDetailList')
    onChangeInboundDeliveryNotesDetailList() {
        this.canChangeWarehouse = this.InboundDeliveryNotesDetailList.length > 0;
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : IInboundDeliveryNotes | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedInboundDeliveryNotes = [];
        } else {
            this.selectedInboundDeliveryNotes = [newValue];
            this.$emit('inboundDeliveryNotesChanged', this.selectedInboundDeliveryNotes[0]);
        }
    }
  
    @Watch('selectedCompanyDestination')
    onChangeSelectedCompanyDestination() {
        this.editedItem.idCompanyDestination = this.selectedCompanyDestination.id;
        this.editedItem.companyDestinationName = this.selectedCompanyDestination.name;
    }

    get companyFilteredByInboundSelected() {
        return this.CompanyList.filter(c => c.id === this.SelectedInbound.idCompanyDestination);
    }
  
    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.SelectedInbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    resetInboundDeliveryNotes() {
        this.selectedInboundDeliveryNotes = [];
        this.editedItem = Object.assign({}, this.defaultItem);
        const nextNumber = (this.InboundDeliveryNotesList.length + 1).toString().padStart(2, '0');
        this.editedItem.code = `${this.SelectedInbound.code}-${nextNumber}`;
        this.selectedCompanyDestination = this.CompanyList.find(r => r.id === this.SelectedInbound.idCompanyDestination) as ICompany;
        this.selectedWarehouse = null;
        this.dateIn = moment(new Date(this.SelectedInbound.dateIn)).format('YYYY-MM-DD');
        this.selectedDock = {} as IListDock;
        this.$emit('resetInboundDeliveryNotes');
    }

    editInboundDeliveryNotes (item: any, dbox = true) {
        if (this.selectedInboundDeliveryNotes.length > 0) {
            this.editedIndex = this.InboundDeliveryNotesList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedWarehouse = this.WarehouseList.find(p => p.id === this.editedItem.idWarehouse) as IWarehouse;
            this.selectedCompanyDestination = this.CompanyList.find(r => r.id === this.editedItem.idCompanyDestination) as ICompany;
            this.selectedStatus = this.ListStatusInboundsDeliveryNotes.find(s => s.id === this.editedItem.idStatus) as IListStatusInboundDeliveryNotes;
            this.dateIn = moment(new Date(item.dateIn)).format('YYYY-MM-DD');
            this.selectedDock = this.ListDocks.find(d => d.id === this.editedItem.idDock) as IListDock;
            this.dialog = true;
        }
    }

    saveInboundDeliveryNotes () {
        if (this.SelectedInbound.statusName === 'Completed' && this.CanModifyCompletedInbounds === false) {
            this.close();
        } else {
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                if (this.editedItem.code === "" && this.IsSelectedWarehouseShared) {
                    this.showMessageWarning('Code must be filled out.');
                    return;
                }

                this.editedItem.dateIn = new Date(this.dateIn);
                this.editedItem.idCompanySource = this.SelectedInbound.idCompanySource;
                this.editedItem.companySourceName = this.SelectedInbound.companySourceName;

                // 🚨 Gestión de docks
                if (!this.ScannerActive) {
                    // Cliente sin licencia de Docks → asignar Dock Unknown
                    this.editedItem.idDock = EMPTY_GUID;
                    this.editedItem.dockName = "Dock Unknown";
                } else {
                    if (!this.IsSelectedWarehouseShared) {
                        // Warehouse NO es shared → dock obligatorio
                        if (!this.selectedDock || !this.selectedDock.id) {
                            this.showMessageWarning('Dock must be filled out.');
                            return; // 🚨 salir sin salvar
                        }
                        this.editedItem.idDock = this.selectedDock.id;
                        this.editedItem.dockName = this.selectedDock.name;
                    } else {
                        // Warehouse shared → si no hay dock válido, asignamos Dock Unknown
                        if (!this.selectedDock || !this.selectedDock.id) {
                            this.editedItem.idDock = EMPTY_DOCK_GUID;
                            this.editedItem.dockName = "Dock Unknown";
                        } else {
                            this.editedItem.idDock = this.selectedDock.id;
                            this.editedItem.dockName = this.selectedDock.name;
                        }
                    }
                }

                // 🚨 Guardar / Editar
                if (this.selectedInboundDeliveryNotes.length > 0) {
                    this.close();
                    this.editedIndex = this.InboundDeliveryNotesList.findIndex(i => i.id === this.editedItem.id);
                    this.$emit('editInboundDeliveryNotes', this.editedItem);
                    Object.assign(this.InboundDeliveryNotesList[this.editedIndex], this.editedItem);
                } else {
                    this.editedItem.idWarehouse = this.selectedWarehouse.id;
                    this.editedItem.warehouseName = this.selectedWarehouse.name;
                    this.editedItem.idCompanyDestination = this.selectedCompanyDestination.id;
                    this.editedItem.companyDestinationName = this.selectedCompanyDestination.name;
                    this.editedItem.idCustomer = this.SelectedInbound.idCustomer;
                    this.editedItem.customerName = this.SelectedInbound.customerName;
                    this.editedItem.idInbound = this.SelectedInbound.id;

                    if (this.editedItem.code === "") {
                        const nextNumber = (this.InboundDeliveryNotesList.length + 1).toString().padStart(2, '0');
                        this.editedItem.code = `${this.SelectedInbound.code}-${nextNumber}`;
                    }
                    this.editedItem.codeSource = this.SelectedInbound.code;
                    this.selectedInboundDeliveryNotes[0] = this.editedItem;
                    this.$emit('saveInboundDeliveryNotes', this.editedItem);
                }
            } else {
                this.showMessageWarning('All required fields must be filled out');
            }
        }
    }

    deleteInboundDeliveryNotes (inboundDeliveryNotes: IInboundDeliveryNotes) {
        if (this.selectedInboundDeliveryNotes.length > 0) {
            this.$emit('deleteInboundDeliveryNotes', inboundDeliveryNotes);
            this.close();
        }
    }

    async getStockByInboundAndWarehouse(idInbound: string, idWarehouse: string) {
        await this.$emit('getStockByInboundAndWarehouse', idInbound, idWarehouse);
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    async saveInboundDeliveryNotesDetail(items: IInboundDetail[]) {
        if (!items || items.length === 0) {
            this.showMessageWarning("No details to save");
            return;
        }

        this.overlay = true; // 🚀 Bloqueamos la UI del popup

        try {
            for (const i of items) {
                let inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail = {} as IInboundDeliveryNotesDetail;
                inboundDeliveryNotesDetail.idInboundDeliveryNote = this.selectedInboundDeliveryNotes[0].id;
                inboundDeliveryNotesDetail.goodsPerCase = i.goodsPerCase;
                inboundDeliveryNotesDetail.totalGoods = i.totalGoods;
                inboundDeliveryNotesDetail.location = "";
                inboundDeliveryNotesDetail.weight = i.weight;
                inboundDeliveryNotesDetail.bestBeforeDate = i.bestBeforeDate!;
                inboundDeliveryNotesDetail.idInboundDetail = i.id;
                inboundDeliveryNotesDetail.idGood = i.idGood;
                inboundDeliveryNotesDetail.goodName = i.goodName;
                inboundDeliveryNotesDetail.idListPallet = i.idListPallet;
                inboundDeliveryNotesDetail.palletName = i.palletName;
                inboundDeliveryNotesDetail.palletsAmount = i.palletsAmount;
                inboundDeliveryNotesDetail.casesPerPallet = i.casesPerPallet;
                inboundDeliveryNotesDetail.totalCases = i.totalCases;

                // 👇 Esperamos a que el padre confirme la operación antes de seguir
                await new Promise<void>((resolve, reject) => {
                    this.$emit("saveInboundDeliveryNotesDetail", inboundDeliveryNotesDetail, resolve, reject);
                });
            }

            this.showMessageInfo("All delivery notes detail have been successfully saved");
        } catch (error) {
            this.showMessageError("Error saving details");
            console.error(error);
        } finally {
            this.overlay = false; // ✅ Desbloqueamos el popup al terminar
        }
    }

    deleteInboundDeliveryNotesDetail(item : IInboundDeliveryNotesDetail) {
        this.$emit('deleteInboundDeliveryNotesDetail', item);
    }

    getInboundDetailDeliveryNotes() {
        this.$emit('getInboundDetailDeliveryNotes');
    }

    printInboundDeliveryNotes() {
        this.dialogPrinting = false;
        this.$emit('printInboundDeliveryNotes', this.selectedFormatToPrint);
    }

    select(item : IInboundDeliveryNotes) : void {
        let index : number = this.selectedInboundDeliveryNotes.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedInboundDeliveryNotes = [item];
            this.$emit('input', item);
        } else {
            let inboundDeliveryNotes = this.selectedInboundDeliveryNotes.find(w => w.id === item.id);
            if (!inboundDeliveryNotes) {
                this.selectedInboundDeliveryNotes = [];
                this.$emit('input', null);
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
